import { NavLink } from "react-router-dom";
import renderHTML from "react-render-html";
import { Grid, Button, Container, Link, Typography } from "@mui/material";
import PropTypes from "prop-types";
import dayjs from "dayjs";

import HolidayPresenter from "presenters/HolidayPresenter";
import { appRoutes } from "routes";
import { getHolidaysDays, getCelebratesDays, getGreetingsDays } from "utils/categoriesUtils";

import Description from "./components/Description/Description";
import { Root, StyledGrid, GroupTitle, StyledLink } from "./styles";

const Categories = ({ isDescriptionVisible = true, dateSelected = dayjs() }) => {
  const holidaysColumns = getHolidaysDays(dateSelected);

  const celebrateColumn = getCelebratesDays();

  const greetingsColumn = getGreetingsDays();

  const renderCategory = (category) => (
    <StyledLink
      id={HolidayPresenter.getCategoryId(category)}
      key={HolidayPresenter.name(category)}
      to={appRoutes.categoryPath(HolidayPresenter.slug(category))}
      component={NavLink}
    >
      {renderHTML(HolidayPresenter.title(category))}
    </StyledLink>
  );

  return (
    <Root>
      <Container>
        {isDescriptionVisible && (
          <>
            <Description title="JibJab Ecards">
              <Typography variant="large" align="center" pb={5}>
                Introducing JibJab – where the laughter never stops and the party is always poppin’! Get ready to
                unleash the zaniness and make your peeps double over in stitches with our knee-slappin’ ecards that are
                as goofy as your Uncle Ned after one too many cups of coffee!
              </Typography>
              <Typography variant="large" align="center">
                So, you wanna send a
                <Link to={appRoutes.categoryPath("birthday-ecards")} component={NavLink}>
                  {" "}
                  birthday ecard{" "}
                </Link>
                that’ll have ’em rolling on the floor? Or maybe you’re itching to spread some Merry Christmas cheer with
                a side of hilarity? Perhaps you’re feeling all lovey-dovey and wanna show your better half just how much
                they mean to you? Or hey, are you on a quest to say thank you in the most unforgettable way ever? Well,
                folks, we’ve gotcha covered! Just hunt down the perfect custom greeting card, slap on 1-5 grinning mugs,
                and hit that send button faster than a caffeinated squirrel on roller skates. It’s so darn easy that
                we’ve heard rumors of pets sending our personalized greeting cards online…who knew Fluffy was so funny?!
              </Typography>
            </Description>
            <Description title="You Bring the Faces, We Bring the Smiles">
              <Typography variant="large" align="center" pb={5}>
                At JibJab, we firmly believe that laughter is the best darn medicine this side of the moon. And guess
                what? You don’t need to enroll in medical school to become a certified ecard maker! Brighten up
                someone’s day by sending ’em some of our signature LOLs. We’ll turn ’em into the headliner of their very
                own blockbuster flick, or let ’em break it down like a dancefloor dynamo with our rockin’
                <Link to={appRoutes.categoryPath("music-video-ecards")} component={NavLink}>
                  {" "}
                  music video ecards.{" "}
                </Link>
                We’ve been crafting these world-famous cards for so long that we’ve got online cards for just about any
                reason you can dream up... and heck, some reasons we straight-up invented ourselves!
              </Typography>
              <Typography variant="large" align="center">
                So there you have it, friends! JibJab – where the laughter flows like soda at a burp contest and the
                good times never run dry. Get ready to be the ecard guru of your crew, and let the chuckles rain down
                like confetti at a clown’s birthday bash!
              </Typography>
            </Description>
          </>
        )}

        <StyledGrid container>
          <Grid item xs={12} sm={6}>
            <Grid container>
              <Grid item xs={12}>
                <GroupTitle variant="h3" categoryColor="holidays">
                  Holidays
                </GroupTitle>
              </Grid>
              {holidaysColumns.map((column, index) => (
                <Grid key={index} item xs={6}>
                  {column.map((category) => renderCategory(category))}
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container>
              <Grid item xs={6}>
                <GroupTitle variant="h3" categoryColor="celebrate">
                  Celebrate
                </GroupTitle>
                {celebrateColumn.map((category) => renderCategory(category))}
              </Grid>
              <Grid item xs={6}>
                <GroupTitle variant="h3" categoryColor="greetings">
                  Greetings
                </GroupTitle>
                {greetingsColumn.map((category) => renderCategory(category))}
              </Grid>
            </Grid>
          </Grid>
        </StyledGrid>

        <Grid container direction="row" justifyContent="center" alignItems="center">
          <Grid item>
            <Button
              id="home-browse-all-categories"
              component={NavLink}
              variant="outlined"
              color="primary"
              to={appRoutes.categoriesPath()}
            >
              Browse All Categories
            </Button>
          </Grid>
        </Grid>
      </Container>
    </Root>
  );
};

Categories.propTypes = {
  isDescriptionVisible: PropTypes.bool,
  dateSelected: PropTypes.shape(Date),
};

export default Categories;
